import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  BackNextButton,
  AddButton,
  Modal,
  EditCard,
  Button,
} from "../../../../../common";
import { EditCardItems } from "../EditCardItems";
import { Search } from "../Details/SearchCompanyWithCountry";
import { AddCompanyName } from "../Details/AddCompanyName";
import { ReactComponent as Delete } from "../../../../../../assets/images/companyIcons/delete1.svg"
// import {
//   useSearchCompanyQuery,
//   useSearchTrevexCompanyQuery,
// } from "../../../../../../store/search/searchApiSlice";
import { isVerified } from "../../../../../../utils/Helper";
import useSearchCompany from "../../../../../../Hooks/useSearchCompany";

import {
  useCreateInsuranceMutation,
  useUpdateInsuranceMutation,
  useCreateCompanyMutation,
  useCreateInsuranceDraftMutation,
  useGetCompanyQuery, useCreateInsuranceDraftFetchMutation, useUpdateInsuranceDraftMutation, useDeleteInsuranceDraftMutation
} from "../../../../../../store/Company/companyApiSlice";
import { useSelector, useDispatch } from "react-redux";
import { AddInsuranceForm } from "./AddInsuranceForm";
import { setInsuranceData } from "../../../../../../store/Company/companySlice";
import { ReactComponent as Address } from "../../../../../../assets/images/companyIcons/CompanyProfile/address.svg";
import { ReactComponent as Pen } from "../../../../../../assets/images/companyIcons/pen.svg";
import { setCurrentEditingCompany } from "../../../../../../store/Company/companySlice";
import useCompanyUpdate from "../useCompanyFollowUpdate"
import { ReactComponent as Verified } from "../../../../../../assets/icons/verified.svg";
import { ReactComponent as Declined } from "../../../../../../assets/icons/cancel.svg";
import { ReactComponent as Requested } from "../../../../../../assets/icons/pending.svg";
import { ReactComponent as Skipped } from "../../../../../../assets/icons/review.svg";

export const Insurance = ({ onPrev, onNext, onSkip, handleUpdateStatus, compRefetch }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [bankInfo, setBankInfo] = useState(false);
  const [showSearch, setShowSearch] = useState("");
  const [addName, setAddName] = useState("");
  const [showOptionName, setShowOptionName] = useState("");
  const [currentCompanyId, setCurrentCompanyId] = useState("");
  const [showAddCompany, setShowAddCompany] = useState(false);
  const [showForm, setShowForm] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState();
  const [selectedCompanyBroker, setSelectedCompanyBroker] = useState();
  const [currentBrokerCompanyID, setCurrentBrokerCompanyID] = useState();
  const [currentInsuranceID, setCurrentInsuranceID] = useState();
  const [showThisCom, setShowThisCom] = useState(false);
  const [insurance, setInsurance] = useState([]);
  const [insuranceDraft, setInsuranceDraft] = useState([]);
  const [insurer_comp_ID, setinsurer_comp_ID] = useState(null)
  const [selectedInsurance, setselectedInsurance] = useState(null)
  const [deleteDraft] = useDeleteInsuranceDraftMutation()
  const [dataChanged, setDataChanged] = useState(false);

  const [selectedInsuranceType, setSelectedInsuranceType] = useState();
  const [editType, setEditType] = useState("");

  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token } = useSelector((state) => state.auth);
  const [createCompany] = useCreateCompanyMutation();
  const [error, setError] = useState("")

  const handleUpdateCompany = useCompanyUpdate();
  const [createInsurance] = useCreateInsuranceMutation();
  const [updateInsurance] = useUpdateInsuranceMutation();
  const [createInsuranceDraft] = useCreateInsuranceDraftMutation();
  const [updateInsuranceDraft] = useUpdateInsuranceDraftMutation();
  const [CreateInsuranceDraftFetch] = useCreateInsuranceDraftFetchMutation();
  const [country, setCountry] = useState({
    name: "Select Country",
    flag: null,
    code: null,
  });
  useEffect(() => {
    if (!currentEditingCompany) return;
    let resultArr = [];
    let Dettemp = currentEditingCompany?.insuranceDetails?.forEach(function (obj) {
      if (obj?.insuranceID?.is_deleted == 0) {
        resultArr.push(obj)
      }
    });
    setInsurance(resultArr);
    companyStatus();
  }, [currentEditingCompany]);

  const companyStatus = async () => {
    let dataval = await CreateInsuranceDraftFetch({
      companyID: currentEditingCompany?.companyID,
      token,
    });
    if (dataval?.data?.data) {
      let respData = dataval?.data?.data;
      let tempArr = [];
      let draft_ids = [];
      let ids = [];
      let main_ids = [];
      for (let i = 0; i < respData.length; i++) {
        draft_ids.push(respData[i]?.insuranceID_id);
        tempArr.push(respData[i]);
      }
      currentEditingCompany?.insuranceDetails?.forEach(function (obj) {
        if (obj?.insuranceID?.is_deleted == 0) {
          ids.push(obj?.insuranceID?.insuranceID)
        }
      });
      ids?.forEach(function (id) {
        if (!draft_ids.includes(id))
          main_ids.push(id)
      })
      currentEditingCompany?.insuranceDetails?.forEach(function (obj) {
        if (obj?.insuranceID?.is_deleted == 0) {
          if (main_ids.includes(obj?.insuranceID?.insuranceID)) {
            tempArr.push(obj?.insuranceID)
          }
        }
      });
      setInsuranceDraft(tempArr)
    }
  }
  function searchCompany(fn, wait) {
    let timeout;
    return function (...args) {
      const context = this;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        timeout = null;
        fn.apply(context, args);
      }, wait);
    };
  }

  const { data: newData, refetch } = useGetCompanyQuery({
    companyId: currentEditingCompany?.companyID,
    token,
  });

  useEffect(() => {
    if (newData) {
      dispatch(setCurrentEditingCompany(newData));
    }
  }, [newData]);

  var searchByCountry = country?.code;

  const searchOnChange = useCallback(searchCompany(setSearchQuery, 400), []);

  const { worldBoxToken } = useSelector((state) => state.search);

  const { data, isLoading, message } = useSearchCompany(
    searchQuery,
    searchByCountry,
    token,
    worldBoxToken
  );
  useEffect(() => {
    if (data) {
      setSearchResults(data);
    }
  }, [data, dataChanged]);

  useEffect(() => {
    setCurrentCompanyId(currentEditingCompany?.companyID);
  }, []);
  // const handleRelatedSubmit = (entity) => {
  //   setSelectedCompany(entity);
  //   handleFormShow();
  // };
  const modalHandle = (insuranceID, isEdit) => {
    setEditType(isEdit);
    setIsOpen(!isOpen);
    setSearchResults([]);
    setSelectedCompany(null);
    setSelectedCompanyBroker(null);
    setSearchQuery("");
    refetch();
    if (isEdit === "edit") {
      setselectedInsurance(insuranceID)
      setSelectedCompany(insuranceID?.insurer);
      setSelectedCompany(insuranceID?.insurer);
      setinsurer_comp_ID(insuranceID?.insurer_comp_ID);
      setSelectedCompanyBroker(
        insuranceID?.broker_company_ID?.registered_company_name || insuranceID?.broker
      );
      setSelectedInsuranceType(insuranceID?.type);
      setCurrentBrokerCompanyID(insuranceID?.broker_company_ID?.companyID);
      setCurrentInsuranceID(insuranceID?.insuranceID);
    }
  };
  const handleAddNewCompany = (type) => {
    if (type) {
      setAddName(type);
    }
    setShowAddCompany((prev) => !prev);
    setShowThisCom((prev) => !prev);
    setSearchResults([]);
    if (!type) {
      setSelectedCompany(null);
      setSelectedCompanyBroker(null);
    }
    setSearchQuery("");
  };
  const handleSearchShow = () => {
    setShowThisCom((prev) => !prev);
    setShowForm((prev) => !prev);
  };

  const handleFormShow = async (type) => {
    setSearchResults([]);
    if (type === "broker" || type === "insurer") {
      setShowSearch(type);
    } else if (selectedCompany || selectedCompanyBroker) {
      setShowThisCom(false);
      setShowForm(true);
      setShowAddCompany(false);
    }
  };

  // const handleBeforeFormShow = () => {
  //   if (selectedCompany || selectedCompanyBroker) {
  //     setShowThisCom(false);
  //     setShowForm(true);
  //     setShowAddCompany(false);
  //   }
  // };
  const handleSearch = (searchTerm) => {
    if (searchTerm.length < 3) {
      setSearchResults([]);
    }
    if (searchTerm.length >= 3) {
      searchOnChange(searchTerm);
    }
  };
  const getSelectedCompany = (company) => {
    setSelectedCompany(company);
  };
  const getSelectedCompanyBroker = (company) => {
    setSelectedCompanyBroker(company);
  };

  const handleStateCompanySelect = (company) => {
    if (addName === "insurer") {
      setSelectedCompany(company)
    } else if (addName === "broker") {
      setSelectedCompanyBroker(company)
    }
  }

  const insuranceInformation = async (e) => {
    const insurerwin = selectedCompany?.win;
    let selectedCompId = selectedCompany?.companyID;
    if (insurerwin) {
      if (selectedCompId === null || selectedCompId === undefined) {

        try {
          const { data, status } = await createCompany({
            data: {
              registered_company_name: selectedCompany?.name,
              country_code: selectedCompany?.country,
              wb_win: selectedCompany?.win,
            },
            registered_company_name: selectedCompany?.name,
            country_code: selectedCompany?.country,
            token,
          });
          selectedCompId = data?.data?.companyID;
        } catch (error) {

        }
      }
    }
    const brokerwin = selectedCompanyBroker?.win;
    var idBrokerCompany = selectedCompanyBroker?.companyID;


    if (brokerwin) {
      if (idBrokerCompany === null || idBrokerCompany === undefined) {

        try {
          const { data, status } = await createCompany({
            data: {
              registered_company_name: selectedCompanyBroker?.name,
              country_code: selectedCompanyBroker?.country,
              wb_win: selectedCompanyBroker?.win,
            },
            registered_company_name: selectedCompany?.name,
            country_code: selectedCompany?.country,
            token,
          });
          var idBrokerCompany = data?.data?.companyID;
        } catch (error) {

        }
      }
    }
    const verifiedData = currentEditingCompany?.verifiedCompany;
    if (isVerified(verifiedData)) {
      if (editType === "edit") {
        try {
          if (selectedInsurance?.insurance_draftID) {
            if (selectedInsurance?.insuranceID_id != undefined && selectedInsurance?.insuranceID_id != null) {
              const res = await updateInsuranceDraft({
                token,
                insuranceID: selectedInsurance?.insurance_draftID,
                data: {
                  type: showOptionName || selectedInsurance?.type,
                  current_companyID: currentCompanyId || selectedInsurance?.current_companyID,
                  request_type: 'Create draft api calling',
                  insurer: selectedCompany?.name || selectedCompany?.registered_company_name || selectedInsurance?.insurer,
                  insurer_comp_ID: selectedCompId || insurer_comp_ID?.insurer_comp_ID?.companyID || selectedInsurance?.insurer_comp_ID,
                  broker: selectedCompanyBroker?.name || selectedCompanyBroker?.registered_company_name || selectedInsurance?.broker,
                  broker_company_ID: idBrokerCompany || selectedInsurance?.broker_company_ID,
                  insuranceID: currentInsuranceID || selectedInsurance?.insuranceID_id,
                },
              });
              if (res) {
                companyStatus()
              }
            } else {
              const res = await updateInsuranceDraft({
                token,
                insuranceID: selectedInsurance?.insurance_draftID,
                data: {
                  type: showOptionName || selectedInsurance?.type,
                  current_companyID: currentCompanyId || selectedInsurance?.current_companyID,
                  request_type: 'Create draft api calling',
                  insurer: selectedCompany?.name || selectedCompany?.registered_company_name || selectedInsurance?.insurer,
                  insurer_comp_ID: selectedCompId || insurer_comp_ID?.insurer_comp_ID?.companyID || selectedInsurance?.insurer_comp_ID,
                  broker: selectedCompanyBroker?.name || selectedCompanyBroker?.registered_company_name || selectedInsurance?.broker,
                  broker_company_ID: idBrokerCompany || selectedInsurance?.broker_company_ID,
                  status: 'pending',
                },
              });
              if (res) {
                companyStatus()
              }
            }
          } else {
            const currentSelected = currentEditingCompany?.insuranceDetails?.filter(
              (insuranceDetails) => insuranceDetails?.insuranceID?.insuranceID === currentInsuranceID
            );
            const currentSelectedCompany = currentSelected.length > 0 ? currentSelected[0] : null
            const data = {
              current_companyID: currentCompanyId || currentSelectedCompany?.insuranceID
                ?.company_insuranceID,
              type: showOptionName || currentSelectedCompany?.insuranceID
                ?.type,
              request_type: 'Create draft api calling',
              insurer: selectedCompany?.name || selectedCompany?.registered_company_name || currentSelectedCompany?.insuranceID?.insurer,
              insurer_comp_ID: selectedCompId || insurer_comp_ID?.insurer_comp_ID?.companyID || currentSelectedCompany?.insuranceID
                ?.insurer_company_ID?.companyID,
              broker: selectedCompanyBroker?.name || selectedCompanyBroker?.registered_company_name || currentSelectedCompany?.insuranceID
                ?.broker_company_ID?.registered_company_name,
              broker_company_ID: idBrokerCompany || currentSelectedCompany?.insuranceID
                ?.broker_company_ID?.companyID,
              status: 'pending',
              insuranceID: currentInsuranceID
            }
            const res = await createInsuranceDraft({ token, data });
            if (res) {
              companyStatus()
            }
          }

        } catch (error) {

        }
      }
      else {
        try {
          const res = await createInsuranceDraft({
            token,
            data: {
              current_companyID: currentCompanyId,
              type: showOptionName,
              request_type: 'Create draft api callingk',
              insurer: selectedCompany?.name || selectedCompany?.registered_company_name,
              insurer_comp_ID: selectedCompId || insurer_comp_ID?.insurer_comp_ID?.companyID,
              broker: selectedCompanyBroker?.name || selectedCompanyBroker?.registered_company_name,
              broker_company_ID: idBrokerCompany,
              broker_country: selectedCompanyBroker?.country,
              broker_state: selectedCompanyBroker?.state,
              insurer_country: selectedCompany?.country,
              insurer_state: selectedCompany?.state,
              status: 'pending',
              insuranceID: currentInsuranceID,
            }
          })
          if (res) {
            companyStatus()
          }

        } catch (error) {

        }
      }
    }
    else {
      if (editType === "edit") {
        try {
          const res = await updateInsurance({
            token,
            insuranceID: currentInsuranceID,
            data: {
              current_companyID: currentCompanyId,
              type: showOptionName,
              insurer:
                selectedCompany?.name ||
                selectedCompany?.registered_company_name,
              insurer_company_ID: selectedCompId,

              broker_company_ID: currentBrokerCompanyID,
              broker:
                selectedCompanyBroker?.name ||
                selectedCompanyBroker?.registered_company_name,
            },
          });
          if (res) {
            companyStatus()
            const result = await handleUpdateCompany(currentEditingCompany.companyID, "Insurance Updated", token);
            if (!result.success) {
              console.error(result.error);
            }
          }
          if (res) {
            dispatch(setInsuranceData(res));
          }
        } catch (error) {
          if (error.status === 401) {
          } else {
          }
        }
      } else {
        try {
          const res = await createInsurance({
            broker_company_ID: idBrokerCompany,
            data: {
              current_companyID: currentCompanyId,
              type: showOptionName,
              insurer_company_ID: selectedCompId,
              insurer:
                selectedCompany?.name ||
                selectedCompany?.registered_company_name,
              broker_company_ID: idBrokerCompany,
              broker:
                selectedCompanyBroker?.name ||
                selectedCompanyBroker?.registered_company_name,
              broker_country: selectedCompanyBroker?.country,
              broker_state: selectedCompanyBroker?.state,
              insurer_country: selectedCompany?.country,
              insurer_state: selectedCompany?.state,
            },
            token,
          }).unwrap();
          if (res) {
            companyStatus()
            const result = await handleUpdateCompany(currentEditingCompany.companyID, "New Insurance Added", token);
            if (!result.success) {
              console.error(result.error);
            }
          }

          if (res) {
            dispatch(setInsuranceData(res));
          }
        } catch (error) {
        }
      }
    }
    setBankInfo(true);
    modalHandle(e);
  };
  const handleOption = (e) => {
    if (e != undefined) {
      setShowOptionName(e);
    }
  };
  function createArrayFromObject(object) {
    let otherData = ["type", "insurer", "broker"];
    let icons = {
      type: <Address />,
      insurer: <Address />,
      broker: <Address />,
    };

    const newObject = {
      company_insuranceID: object?.insuranceID,
      type: object?.type,
      insurer: object?.insurer,
      broker: object?.broker_company_ID?.registered_company_name || object?.broker,
    };

    let data = [];

    for (let key in newObject) {
      if (otherData.includes(key)) {
        data.push({ [key]: newObject[key], icon: icons[key] });
      }
    }

    let keyValuePairs = data.map((item) =>
      Object.entries(item).map(([key, value]) => [key, value])
    );

    let html = keyValuePairs.map((item) => (
      <EditCardItems
        heading={item[0][0]?.replaceAll("_", " ")}
        subHeading={item[0][1]?.replace("|", "")}
        icon={item[1][1]}
      />
    ));
    return html;
  }
  const modalHandleDelete = async (deleteInfo) => {
    if (deleteInfo?.insurance_draftID) {
      let dataval = await deleteDraft({
        data: deleteInfo?.insurance_draftID,
      });
      if (dataval?.data == null) {
        alert("Insurance Information Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    } else if (deleteInfo?.insuranceID) {
      const formData = new FormData();
      formData.append("is_deleted", 1);
      let res = await updateInsurance({
        data: formData,
        insuranceID: deleteInfo?.insuranceID,
        token,
      }).unwrap();
      if (res?.is_deleted == 1) {
        handleUpdateStatus()
        alert("Insurance Information Deleted Successfully");
        compRefetch();
        refetch()
        setDataChanged(!dataChanged);
        // window.location.reload()
      }
    }
  }
  return (
    <div className="mt-5 mr-20">
      {isOpen && (
        <Modal modalHandle={modalHandle}>
          {showForm && (
            <AddInsuranceForm
              onSearch={handleSearchShow}
              selectedCompany={selectedCompany}
              selectedCompanyBroker={selectedCompanyBroker}
              selectedInsuranceType={selectedInsuranceType}
              showForm={handleFormShow}
              insuranceInfo={insuranceInformation}
              optionName={handleOption}
              showOptionName={showOptionName}
              refetch={refetch}
              compRefetch={compRefetch}
              dataChanged={dataChanged}
              setDataChanged={setDataChanged}
            />
          )}
          {showThisCom && showSearch === "insurer" && (
            <Search
              onSearch={handleSearch}
              results={searchResults}
              isLoading={isLoading}
              label={"Select your Insurer"}
              type="insurer"
              getSelectedCompany={getSelectedCompany}
              showForm={handleFormShow}
              handleSearchShow={handleSearchShow}
              handleAddNewCompany={handleAddNewCompany}
              breadPrev="Add Insurance Information"
              breadNext="Select Insurer"
              searchLabel="Search your Insurer"
              searchEmptyText="Search & Select your Insurer"
              setCountry={setCountry}
              country={country}
              error={error}
              message={message}
            />
          )}
          {showThisCom && showSearch === "broker" && (
            <Search
              onSearch={handleSearch}
              results={searchResults}
              isLoading={isLoading}
              label={"Select your Broker"}
              type="broker"
              getSelectedCompany={getSelectedCompanyBroker}
              showForm={handleFormShow}
              handleSearchShow={handleSearchShow}
              handleAddNewCompany={handleAddNewCompany}
              breadPrev="Add Insurance Information"
              breadNext="Select Broker"
              searchLabel="Search your Broker"
              searchEmptyText="Search & Select your Broker"
              setCountry={setCountry}
              country={country}
              error={error}
              message={message}
            />
          )}
          {showAddCompany && (
            <AddCompanyName
              handleCompanySubmit={handleFormShow}
              breadNext={"Add Company Name"}
              breadPrev={"Select company"}
              label={addName === "insurer" ? "Add Insurer Name" : "Add Broker Name"}
              handleSelectedCompany={handleStateCompanySelect}
            />
          )}
        </Modal>
      )}
      <h3 className="text-f20 font-semibold text-secondarytwo text-left mb-2">
        Insurance
      </h3>

      <div className="border border-slate rounded-lg p-8 mb-6 hell">
        <AddButton
          text="Add Insurance Information"
          buttonText="Add Insurance"
          onClick={modalHandle}
        />

        <div className="grid grid-cols-2 gap-4">
          {insuranceDraft.length <= 0 && insurance?.map((item) => (
            <EditCard className="h-[24rem] overflow-y-auto relative  my-2">
              <div className="statusSection">
                {item.insuranceID.status === "Verified" && (
                  <Verified />
                )}
                {item.insuranceID.status === "Declined" && (
                  <Declined />
                )}
                {item.insuranceID.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.insuranceID?.status === "Requested" || item?.insuranceID?.status === "raised" || item?.insuranceID?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="mb-5 my-2">
                {createArrayFromObject(item?.insuranceID)}
              </div>
              <div className="actionseditDelete  gap-4">

                <Button
                  onClick={() => modalHandle(item?.insuranceID, "edit")}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item?.insuranceID)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>
          ))}
          {insuranceDraft?.map((item) => (
            <EditCard className="h-[24rem] overflow-y-auto relative  my-2">
              <div className="statusSection">
                {item.status === "Verified" && (
                  <Verified />
                )}
                {item.status === "Declined" && (
                  <Declined />
                )}
                {item.status === "Skipped" && (
                  <Skipped />
                )}
                {(item?.status === "Requested" || item?.status === "raised" || item?.status === "pending") && (
                  <Requested />
                )}
              </div>
              <div className="mb-5 my-2">
                {createArrayFromObject(item)}
              </div>
              <div className="actionseditDelete  gap-4">

                <Button
                  onClick={() => modalHandle(item, "edit")}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Edit Details</span>
                  <span>
                    <Pen />
                  </span>
                </Button>
                <Button
                  onClick={() => modalHandleDelete(item)}
                  classes="bg-white/[.2] w-full border border-white/[0.3] rounded flex items-center justify-center gap-2 p-2 text-white relative"
                >
                  <span>Delete</span>
                  <span>
                    <Delete />
                  </span>
                </Button>
              </div>
            </EditCard>

          ))}
        </div>
      </div>

      <BackNextButton
        onPrev={() => onPrev(0, "Banking Information", "Financial")}
        onNext={() => onNext(2, "Auditor Information", "Financial")}
        onSkip={() => onSkip(2, "Auditor Information", "Financial")}

      />
    </div>
  );
};
